<template>
  <div class="fixed-sn">
    <div class="wrapper container">
      <header style="display: none;">
        <!---->
        <!---->
      </header>
      <div data-v-2d018e31="" class="bg-wrapper" loadingactive="[object Object]">
        <div data-v-2d018e31="">
          <form data-v-2d018e31="" class="login-section">
            <div data-v-2d018e31="" class="card">
              <div data-v-2d018e31="" class="login-footer py-2 justify-content-center"
                style="padding-top: 1rem !important; border-bottom: 1px solid rgb(255, 255, 255); padding-bottom: 1rem !important;">
                <div data-v-2d018e31="" class="btn-group"><a data-v-2d018e31="" href="" data-toggle="dropdown"
                    aria-haspopup="true" aria-expanded="false" class="nav-link dropdown-toggle"><img data-v-2d018e31=""
                      src="../assets/img/flag/usa.png" alt="" width="20" height="20"><span data-v-2d018e31=""
                      class="ml-2" style="color: white; font-weight: bold;">English</span></a>
                  <div data-v-2d018e31="" class="dropdown-menu"><a data-v-2d018e31="" class="dropdown-item"><img
                        data-v-2d018e31="" src="../assets/img/flag/thailand.png" alt="" width="20" height="20"><span
                        data-v-2d018e31="" class="ml-2">Thai</span></a>
                    <div data-v-2d018e31="" class="dropdown-divider"></div><a data-v-2d018e31=""
                      class="dropdown-item"><img data-v-2d018e31="" src="../assets/img/flag/usa.png" alt="" width="20"
                        height="20"><span data-v-2d018e31="" class="ml-2">English</span></a>
                    <div data-v-2d018e31="" class="dropdown-divider"></div>
                  </div>
                </div>
              </div>
              <hr data-v-2d018e31="" class="m-0 d-none d-lg-block" style="height: 1px; background-color: white;">
              <div data-v-2d018e31="" class="card-header text-center"><a data-v-2d018e31="" href=""
                  class="logo mx-auto pb-4 mb-1" style="background-color: transparent;"><img data-v-2d018e31=""
                    src="../assets/img/logo1.png" alt="logo"></a></div>
              <div data-v-2d018e31="" class="card-body">
                <div data-v-2d018e31="" class="card-body-holder">
                  <div data-v-2d018e31="" class="form-group row mb-4">
                    <div data-v-2d018e31="" class="col-12">
                      <div data-v-2d018e31="" class="md-form md-outline"><input @keyup.enter="Login()"
                          v-model="userName" data-v-2d018e31="" type="text" id="inputUserName" required="required"
                          class="form-control"><label :class="{ active: userName.length > 0 }" data-v-2d018e31=""
                          for="inputUserName" class="label">Username</label></div>
                    </div>
                  </div>
                  <div data-v-2d018e31="" class="form-group row mb-4">
                    <div data-v-2d018e31="" class="col-12">
                      <div data-v-2d018e31="" class="md-form md-outline"><input @keyup.enter="Login()"
                          v-model="Password" data-v-2d018e31="" id="inputPassword" required="required" :type="showPassword == true ? 'text' : 'password'"
                          class="form-control"><label :class="{ active: Password.length > 0 }" data-v-2d018e31=""
                          for="inputPassword" class="label">Password</label><span @click="setshowPassword()" data-v-2d018e31=""
                          class="toggle-password field-icon"><i data-v-2d018e31="" class="far fa-eye"></i></span></div>
                    </div>
                  </div>
                  <div data-v-2d018e31="" class="form-group row mb-4">
                    <div data-v-2d018e31="" class="col-12"><button data-v-2d018e31="" type="button" @click="Login()"
                        id="login" class="btn btn-lg btn-yellow font-weight-bold btn-block">Sign In</button></div>
                  </div>
                  <div data-v-2d018e31="" class="note-text white-text text-center"><span data-v-2d018e31="">Contact your
                      associate in case you forgot the password or unable to sign in.</span></div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div id="modal-main" role="dialog" tabindex="-1" aria-hidden="true" class="modal fade"></div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Swal from "sweetalert2";

export default {
  name: "Login",
  data() {
    return {
      userName: "",
      Password: "",
      showPassword: false,
    };
  },
  computed: {
    ...mapGetters(["getError"]),
  },
  methods: {
    ...mapActions(["userSignIn", "setError"]),
    async setshowPassword(){
      this.showPassword = (this.showPassword === true) ? false: true;
    },
    async Login() {
      if (this.userName == "" || this.Password == "") {
        return Swal.fire("กรุณากรอกข้อมูลให้ครบถ้วน", "", "warning");
      }
      await this.userSignIn({
        username: this.userName,
        password: this.Password,
      });
      if (this.getError) {
        return Swal.fire(this.getError, "", "error");
      }
    },
  },
};
</script>
<style scoped>
.bg-wrapper[data-v-2d018e31] {
  position: fixed;
  top: 0;
  left: 0;
  overflow: hidden
}

.bg-wrapper[data-v-2d018e31],
.bg[data-v-2d018e31] {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center
}

.bg[data-v-2d018e31] {
  position: relative;
  background-color: #fff !important;
  background-position: 50%;
  background-size: cover
}
</style>